/**
 * Maps Altruon StyleContext to Basis Theory Elements theme tokens, from the same fields
 * mapStylesToCheckoutFlow reads, so both card forms look alike for a merchant's skin.
 *
 * @param {Object} styles - Altruon styles from StyleContext
 * @returns {Object} Basis Theory `theme` (SDK option)
 */
export const mapStylesToBasisTheoryTheme = (styles) => {
  const fontFamily =
    styles?.typography?.fontFamily ||
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif';

  return {
    colors: {
      primary:
        styles?.components?.button?.primary?.backgroundColor ||
        styles?.colors?.primary ||
        "#5E48FC",
      error: styles?.components?.errorMessage?.color || "#EF4444",
      success: styles?.colors?.success || "#10B981",
      text: {
        primary: styles?.colors?.textPrimary || "#020303",
        placeholder: styles?.colors?.textSecondary || "#6B7280",
      },
      background: {
        default: styles?.components?.input?.backgroundColor || "#FFFFFF",
      },
      border: {
        default: styles?.components?.input?.borderColor || "#E5E7EB",
        hover: styles?.components?.input?.borderColorHover || "#D1D5DB",
        focus: styles?.colors?.borderFocus || styles?.colors?.primary || "#5E48FC",
        error: styles?.components?.errorMessage?.color || "#EF4444",
      },
    },
    typography: {
      fontFamily,
      fontSize: { base: styles?.components?.input?.fontSize || "14px" },
      fontWeight: {
        normal: String(parseInt(styles?.components?.input?.fontWeight, 10) || 400),
      },
      lineHeight: { normal: "20px" },
    },
    spacing: { sm: "8px", md: "12px", lg: "16px" },
    sizing: { input: { height: "44px" } },
    borders: {
      radius: {
        base:
          styles?.borderRadius?.small ||
          styles?.components?.input?.borderRadius ||
          "8px",
      },
      width: { base: "1px" },
    },
    shadows: {
      focus: "0 0 0 3px rgba(94, 72, 252, 0.18)",
    },
  };
};

/**
 * Basis Theory exposes its regional API hosts as named environments. The backend sends the
 * tenant's API base URL; Elements wants the name.
 */
export const basisTheoryEnvironment = (apiBaseUrl) => {
  if (!apiBaseUrl) return undefined;
  if (apiBaseUrl.includes(".eu.")) return "eu";
  if (apiBaseUrl.includes(".us.")) return "us";
  if (apiBaseUrl.includes(".test.")) return "test";
  return undefined;
};
